import React from 'react';
import { Grid } from '@mui/material';
import getBaseEditor, { CommandPanels } from '../../BaseEditor';
import TPs from './tp';

const editorRenderer = (getControl, {
  data, currentUser, dataSetter,
  fields,
}) => (
  <Grid container spacing={2}>
    <Grid item xl={2} lg={3} md={4} xs={12}>
      {getControl('code')}
    </Grid>
    <Grid item xl={10} lg={9} md={8} xs={12}>
      {getControl('name')}
    </Grid>
    {currentUser.is_superuser && (
      <Grid item md={4} xs={12}>
        {getControl('org', { backend: '/api/catalog/orgs/' })}
      </Grid>
    )}
    <Grid item md={4} xs={12}>
      {getControl('budget', { backend: '/api/catalog/budgets/' })}
    </Grid>
    <Grid item md={4} xs={12}>
      {getControl('kdb', { backend: '/api/catalog/kdbs/' })}
    </Grid>
    <Grid item>
      {getControl('disabled')}
    </Grid>
    <Grid item xs={12}>
      <TPs.GeneralTP
        data={data.ratioaccounthistory_set}
        options={fields.ratioaccounthistory_set}
        onChange={(e, newRecs) => dataSetter({ ratioaccounthistory_set: newRecs })}
      />
    </Grid>

  </Grid>
);

export default getBaseEditor(editorRenderer, '/api/catalog/accounts/', CommandPanels.catCommandPanel);
